import React from 'react';

// Separate Icons file (icons.js) ya yahi rakh sakte ho
const Icons = {
  Performance: () => (
    // Rocket Icon
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      strokeWidth="1.5" stroke="currentColor"
      className="w-8 h-8 text-blue-600">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M15.59 14.37a6 6 0 0 0-5.84-5.84m5.84 5.84L18 21l-6.63-2.41m4.22-4.22-4.22 4.22m0 0L3 21l2.41-8.37m5.96-5.96a6 6 0 0 0-5.84 5.84m5.84-5.84L14.37 3l2.41 6.63" />
    </svg>
  ),

  Security: () => (
    // Shield Icon
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      strokeWidth="1.5" stroke="currentColor"
      className="w-8 h-8 text-blue-600">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M12 3l7.5 3v6c0 5.25-3.75 8.25-7.5 9-3.75-.75-7.5-3.75-7.5-9V6L12 3z" />
    </svg>
  ),

  Support: () => (
    // Headset Icon
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      strokeWidth="1.5" stroke="currentColor"
      className="w-8 h-8 text-blue-600">
      <path strokeLinecap="round" strokeLinejoin="round"
        d="M18 10a6 6 0 1 0-12 0v4a2 2 0 0 0 2 2h2v-4H8v-2a4 4 0 1 1 8 0v2h-2v4h2a2 2 0 0 0 2-2v-4z" />
    </svg>
  )
};

const WhyCloudMigration = () => {
 const benefits = [
  {
    id: 1,
    title: 'Improved Performance',
    description: 'Optimized infrastructure designed for speed, reliability, and scalability.',
    icon: <Icons.Performance />
  },
  {
    id: 2,
    title: 'Enhanced Security',
    description: 'Secure environments with modern best practices and infrastructure controls.',
    icon: <Icons.Security />
  },
  {
    id: 3,
    title: 'Expert Support',
    description: 'End-to-end migration assistance and ongoing technical guidance.',
    icon: <Icons.Support />
  }
];

  return (
    <section id="benefits" className="py-10  transition-all duration-700 opacity-100 translate-y-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Why Cloud Migration?
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div key={benefit.id} className="text-center p-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-2xl mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                {benefit.title}
              </h3>
              <p className="text-gray-600">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
        
      </div>
    </section>
  );
};

export default WhyCloudMigration;